<template>
  <v-card color='primary'>
    <v-container grid-list-md>
      <v-layout row wrap>
      <v-flex xs12 order-xs2>
        <v-card raised>
          <!-- <selfDrawingMap></selfDrawingMap> -->
          <waterBasinUseMap></waterBasinUseMap>
        </v-card>
      </v-flex>
      <v-flex xs12 order-xs1>
        <v-card>
          <v-card-title primary-title>
            <div>
              <div class="headline">Tell us your data</div>
              <div class="headline">We'll tell your story</div>
              <span class="grey--text">The next step in scientific data visualization and communication</span>
            </div>
          </v-card-title>
        </v-card>
      </v-flex>
    </v-flex>
  </v-layout>
</v-container>
</v-card>
</template>
<script>
// import selfDrawingMap from './animations/SelfDrawingMap.vue'
import waterBasinUseMap from './animations/WaterBasinUseMap.vue'
export default {
  data: () => ({
    gradient: 'to top right, rgba(63,81,181, 0), rgba(25,32,72, 0)'
  }),
  components: {
    // selfDrawingMap
    waterBasinUseMap
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Home.vue